import CourseCard from './CourseCard'
import { GlobalProvider, useGlobal } from "../contexts/GlobalContext";
import Wa from '../assets/svg/wa.svg?react'

function Courses() {
  const { t, parse, directusGlobals } = useGlobal();
  return (
    <section id="courses" className="courses py-16 bg-bg-alt-100">
      {/* Title and Body with padding */}
      <div className="courses__header max-w-4xl mx-auto px-8 lg:px-16 mb-12">
        <h2 className="courses__title font-medium font-header text-4xl lg:text-5xl text-secondary-700 text-center mb-12">
          {t("sections_data.4.section_heading")}
        </h2>

        {/* Section Body */}
        <div className="courses__body font-body text-lg text-dark-700 leading-relaxed text-center">
          {parse(t("sections_data.4.section_body"))}
        </div>
      </div>

      {/* Course Cards - Full width on mobile */}
      <div className="courses__container">
        <div className="courses__grid lg:space-y-8 mb-12">
          {t("course_data", {returnObjects: true}).map(course => (

            <CourseCard
              key={course.Course_id}
              image={course.course_cover_image}
              title={course.course_title}
              date={course.course_dates}
              description={course.course_short_description}
              calendlyEmbed={course.course_calendly_embed}
              callToActionButtonText={course.course_call_to_action_text}
            />
          ))}
        </div>

        {/* CTA Button */}
        {/* <div className="courses__cta-wrapper text-center mx-auto">*/}
          <div className="courses__cta-wrapper max-w-4xl mx-auto px-8 lg:px-16 flex justify-center">
            <a
              href={`https://wa.me/${directusGlobals.contact_whatsapp_number}`}
              className="w-fit bg-secondary-500 text-xl border border-solid border-secondary-500 text-white px-8 py-3 hover:text-secondary-500 hover:bg-white font-display font-extralight transition-colors cursor-pointer flex items-center"
              data-umami-event="Contact Button - Whatsapp"
              data-umami-event-name="Under Courses">
              {parse(t("sections_data.4.section_cta"))}
              <Wa className="ml-2 h-5 w-5 fill-current" />
            </a>
          </div>
        {/* </div>*/}
      </div>
    </section>
  )
}

export default Courses
